import { PosBoard } from './PosBoard';

export type BoardPageType = 0 | 1 | 2;
export const getPosBoardItemsFilterByPage = (idx: number, page: BoardPageType) =>
	idx >= page * PosBoard.ITEM_LENTH_PER_PAGE && idx < (page + 1) * PosBoard.ITEM_LENTH_PER_PAGE;
